export const APP_ROUTES = {
    DASHBOARD: '/dashboard',
    SUBMIT_INCIDENT: '/submit',
    INCIDENT_LIST: '/logs',
    INCIDENT_DETAIL: '/incidents/:id',
    SUGGESTIONS: '/suggestions',
    LOGIN: '/login',
    COMPANY: '/company',
    COMPANY_DETAIL: '/company/:id',
    USERS: '/users',
    MY_COMPANY: '/my-company',
    CREATE_COMPANY_ADMIN: '/companies/:id/create-admin',
};
